import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-5" }
const _hoisted_2 = { class: "flex max-sm:flex-wrap gap-2" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col pt-3"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col pt-3"
}

import { Component, computed, ref } from "vue"
import {
    AdjustmentsIcon,
    AnnotationIcon,
    ChatAltIcon,
    ClipboardCheckIcon,
    ClipboardListIcon,
    ClockIcon,
    FireIcon,
    MailIcon,
    OfficeBuildingIcon,
    SearchIcon,
    TagIcon,
    TrashIcon,
    UserCircleIcon,
} from "@heroicons/vue/outline"
import { useWorkflowStore } from "@/stores/workflow"
import { ActionNodeType } from "@/shared/models/workflow"
import ArrowDown from "@/components/icons/ArrowDown.vue"
import ActionCard from "@/components/workflows/sidebar/action/ActionCard.vue"
import ActionItem from "@/components/workflows/sidebar/action/ActionItem.vue"
import SplitIcon from "@/components/icons/SplitIcon.vue"
import GgmsInput from "@/components/GgmsInput.vue"
import NoteComponent from "@/components/workflows/sidebar/action/crm/NoteComponent.vue"
import PropertyValueComponent from "@/components/workflows/sidebar/action/crm/PropertyValueComponent.vue"
import ContactDistributionComponent from "@/components/workflows/sidebar/action/crm/ContactDistributionComponent.vue"
import SendEmailComponent from "@/components/workflows/sidebar/action/communications/SendEmailComponent.vue"
import BranchSidebarComponent from "@/components/workflows/sidebar/BranchSidebarComponent.vue"
import DelaySidebarComponent from "@/components/workflows/sidebar/DelaySidebarComponent.vue"
import ThrottleSidebarComponent from "@/components/workflows/sidebar/ThrottleSidebarComponent.vue"
import SendTextMessageComponent from "@/components/workflows/sidebar/action/communications/SendTextMessageComponent.vue"
import ApplyTagsComponent from "@/components/workflows/sidebar/action/crm/ApplyTagsComponent.vue"
import EnrollOrUnenrollWorkflowComponent from "@/components/workflows/sidebar/action/crm/EnrollOrUnenrollWorkflowComponent.vue"
import DeleteContactsComponent from "@/components/workflows/sidebar/action/crm/DeleteContactsComponent.vue"
import CreateTaskSidebarComponent from "@/components/workflows/sidebar/action/crm/CreateTaskSidebarComponent.vue"
import DNDIcon from "@/components/icons/DNDIcon.vue"
import MarketingPreferencesComponent from "@/components/workflows/sidebar/action/communications/MarketingPreferencesComponent.vue"
import DoNotDisturbComponent from "@/components/workflows/sidebar/action/communications/DoNotDisturbComponent.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'StartSidebarComponent',
  emits: ["changeAction"],
  setup(__props, { emit: __emit }) {

const workflowStore = useWorkflowStore()

const emit = __emit

const isOpenCommunication = ref(true)
const isOpenCrm = ref(true)

const communicationItems = [
    {
        title: "Do Not Disturb",
        description: "Turn on or off Do Not Disturb mode to pause or resume communication with the contact.",
        sidebarComponent: DoNotDisturbComponent,
        icon: DNDIcon,
        useStroke: true,
    },
    {
        title: "Marketing Preferences",
        description:
            "Update the contact’s communication preferences, such as email, text, phone call, and property alerts.",
        sidebarComponent: MarketingPreferencesComponent,
        icon: AdjustmentsIcon,
    },
    {
        title: "Send Email",
        description: "Send a personalized email or template to the contact.",
        sidebarComponent: SendEmailComponent,
        icon: MailIcon,
    },
    {
        title: "Send Text Message",
        description: "Send a personalized text message or template to the contact.",
        sidebarComponent: SendTextMessageComponent,
        icon: ChatAltIcon,
    },
    // {
    //     title: "Send in-app notification (Internal)",
    //     description: "Send a notification to any of your team members",
    //     sidebarComponent: BranchSidebarComponent,
    // },
]

const crmItems = [
    {
        title: "Add or Remove Tags",
        description: "Apply or remove tags to help organize, segment, or trigger other automations.",
        sidebarComponent: ApplyTagsComponent,
        icon: TagIcon,
    },
    {
        title: "Contact Assignment",
        description: "Assign or reassign the contact to a specific agent or team member.",
        sidebarComponent: ContactDistributionComponent,
        icon: UserCircleIcon,
    },
    {
        title: "Create Task",
        description: "Generate a task for you or a teammate to follow up, call, or take action.",
        sidebarComponent: CreateTaskSidebarComponent,
        icon: ClipboardCheckIcon,
    },
    // {
    //     title: "Delete contact",
    //     description: "Permanently remove the contact from your CRM. Use with caution.",
    //     sidebarComponent: DeleteContactsComponent,
    //     icon: TrashIcon,
    // },
    {
        title: "Enroll or Unenroll from Workflows",
        description: "Add or remove the contact from specific workflows.",
        sidebarComponent: EnrollOrUnenrollWorkflowComponent,
        icon: FireIcon,
    },
    {
        title: "Note",
        description: "Log a note on the contact’s profile—great for internal updates or context.",
        sidebarComponent: NoteComponent,
        icon: AnnotationIcon,
    },
    {
        title: "Property Alert(s)",
        description: "Start or stop automated property alerts.",
        sidebarComponent: BranchSidebarComponent,
        icon: OfficeBuildingIcon,
    },
    {
        title: "Update Contact Record",
        description: "Edit or fill in contact details such as name, stage, price range, or custom fields.",
        sidebarComponent: PropertyValueComponent,
        icon: ClipboardListIcon,
    },
    // {
    //     title: "Contact owner",
    //     description: "Description of item",
    //     sidebarComponent: BranchSidebarComponent,
    // },
    // {
    //     title: "Create record",
    //     description: "Description of item",
    //     sidebarComponent: DelaySidebarComponent,
    // },
    // {
    //     title: "Suggest Property",
    //     description: "Description of item",
    //     sidebarComponent: BranchSidebarComponent,
    // },
]

const searchTerm = ref("")

const filteredCommunicationItems = computed(() =>
    communicationItems.filter((item) => item.title.toLowerCase().includes(searchTerm.value.toLowerCase()))
)

const filteredCrmItems = computed(() =>
    crmItems.filter((item) => item.title.toLowerCase().includes(searchTerm.value.toLowerCase()))
)

const iconStyle = computed(() => [workflowStore.disabledBranches ? "fill-gray-400" : "", "h-5 w-5"])

function enterBranches() {
    if (workflowStore.disabledBranches) {
        return
    }
    changeAction({
        title: "Configure branch...",
        sidebarComponent: BranchSidebarComponent,
        type: ActionNodeType.branch,
    })
}
function changeAction(event: { title: string; sidebarComponent?: Component; description?: string; type: string }) {
    emit("changeAction", event)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ActionCard, {
        title: "Delay",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (
                    changeAction({
                        title: 'Configure delay...',
                        sidebarComponent: DelaySidebarComponent,
                        type: _unref(ActionNodeType).delay,
                    })
                ))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ClockIcon), { class: "h-5 w-5 text-gray-900" })
        ]),
        _: 1
      }),
      _createVNode(ActionCard, {
        title: "Throttle",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (
                    changeAction({
                        title: 'Configure throttle...',
                        sidebarComponent: ThrottleSidebarComponent,
                        type: _unref(ActionNodeType).throttle,
                    })
                ))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ClockIcon), { class: "h-5 w-5 text-gray-900" })
        ]),
        _: 1
      }),
      _createVNode(ActionCard, {
        title: "Branch",
        disabled: _unref(workflowStore).disabledBranches,
        onClick: enterBranches
      }, {
        default: _withCtx(() => [
          _createVNode(SplitIcon, {
            class: _normalizeClass(iconStyle.value)
          }, null, 8, ["class"])
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode(GgmsInput, {
      modelValue: searchTerm.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchTerm).value = $event)),
      iconStart: _unref(SearchIcon),
      placeholder: "Search"
    }, null, 8, ["modelValue", "iconStart"]),
    _createElementVNode("div", _hoisted_3, [
      (filteredCommunicationItems.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "flex gap-x-2 cursor-pointer",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (isOpenCommunication.value = !isOpenCommunication.value))
            }, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-base leading-6 font-semibold text-gray-700" }, "Communications", -1)),
              (isOpenCommunication.value)
                ? (_openBlock(), _createBlock(ArrowDown, {
                    key: 0,
                    class: "fill-gray-700"
                  }))
                : (_openBlock(), _createBlock(ArrowDown, {
                    key: 1,
                    class: "rotate-180 fill-gray-700"
                  }))
            ]),
            _createVNode(_Transition, null, {
              default: _withCtx(() => [
                (isOpenCommunication.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCommunicationItems.value, (item) => {
                        return (_openBlock(), _createBlock(ActionItem, {
                          key: item.title,
                          title: item.title,
                          description: item.description,
                          icon: item.icon,
                          useFill: item.useFill ?? false,
                          useStroke: item.useStroke ?? false,
                          onClick: ($event: any) => (changeAction(item))
                        }, null, 8, ["title", "description", "icon", "useFill", "useStroke", "onClick"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (filteredCrmItems.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "flex gap-x-2 mt-6 cursor-pointer",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (isOpenCrm.value = !isOpenCrm.value))
            }, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-base leading-6 font-semibold text-gray-700" }, "CRM", -1)),
              (isOpenCrm.value)
                ? (_openBlock(), _createBlock(ArrowDown, {
                    key: 0,
                    class: "fill-gray-700"
                  }))
                : (_openBlock(), _createBlock(ArrowDown, {
                    key: 1,
                    class: "rotate-180 fill-gray-700"
                  }))
            ]),
            _createVNode(_Transition, null, {
              default: _withCtx(() => [
                (isOpenCrm.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCrmItems.value, (item) => {
                        return (_openBlock(), _createBlock(ActionItem, {
                          key: item.title,
                          title: item.title,
                          description: item.description,
                          icon: item.icon,
                          useFill: item.useFill ?? false,
                          onClick: ($event: any) => (changeAction(item))
                        }, null, 8, ["title", "description", "icon", "useFill", "onClick"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})